import { Ellipsoid } from '@skand/three-js-renderer/bin/private/math';
import { Vector3 } from 'three';
import { toCartesian, toCartographic } from '../../../Utils';
import { BaseCameraMode } from './BaseCameraMode';
/**
 * Camera controls for the Superhero navigation mode.
 *
 * Screen drag - Look around
 * Ctrl-click - Rotate the camera over a selected pivot
 */
export class CameraSuperman extends BaseCameraMode {
    constructor(renderer, gestures) {
        super(renderer, gestures);
        Object.defineProperty(this, "flyToClicked", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.flyToClicked = false;
    }
    /**
     * Calculate the flyTo point given the clicked position
     */
    calculateTarget(screenPosition) {
        const pick = this.renderer.pickScreenWorldSpaceSnapping(screenPosition);
        const position = new Vector3(pick.position.x, pick.position.y, pick.position.z);
        const cartographic = toCartographic(position);
        cartographic.height += 1.8; // 1.8 world units above the selected point
        return toCartesian(cartographic);
    }
    /**
     * Begin flying
     */
    handleCameraActivate() {
        if (!this.isRotating) {
            this.flyToClicked = true;
        }
    }
    /**
     * Fly to view the clicked point
     */
    handleCameraRelease(screenPosition) {
        if (!this.flyToClicked)
            return;
        this.targetPosition = this.calculateTarget(screenPosition);
        const cameraPosition = new Vector3();
        this.camera.getPositionECEF(cameraPosition);
        // Handle clicking on empty space, move only 100 world units forward
        const delta = this.targetPosition.clone().sub(cameraPosition);
        if (delta.length() >= Ellipsoid.WGS_84.radii.length()) {
            delta.normalize().multiplyScalar(100);
            this.targetPosition = cameraPosition.add(delta);
        }
        this.flyToClicked = false;
    }
    /**
     * Implement controls first person camera
     */
    handleCameraDrag(screenPosition, prevPosition) {
        if (this.isRotating) {
            this.flyToClicked = false;
            return;
        }
        // Look-around
        const diffX = screenPosition.x - prevPosition.x;
        const diffY = screenPosition.y - prevPosition.y;
        const angularScale = 0.005;
        this.pitch += angularScale * diffY;
        this.yaw += angularScale * diffX;
        // Threshold to differentiate a tap from a micro-drag
        const eps = 0.5;
        if (diffX * diffX + diffY * diffY > eps * eps) {
            this.flyToClicked = false;
        }
    }
    /**
     * Do not enable flyToClicked if coming from zoom
     */
    handleCameraZoom() {
        this.flyToClicked = false;
    }
}
